/*
 * File: ui-label.ts
 * File Created: 2023-12-18 11:45:26
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-11-07 08:48:15
 * Modified By: Val Liu
 * -----
 */

import {
    BaseUITag,
    EUITagRuleType,
    EUITagRuleUnion,
    EUITagTarget,
    IUITagInput,
    IUITagResult,
    UITag,
} from "./core";

// @uiColumnSize - Define the column size.
// For Form, it's 1-12 bootstrap sizing.
// For Table, it's string base on percent / em / rem / px.
// if null, For Form set class to "col". do nothing in table.

type IUIColumnSize =
    | string
    | {
          "min-width"?: string;
          width?: string;
      };

// @uiColumnSize -
// attach [0-9]% or [0-9]px to table cell, [1]-[12] to form element.
// and also `{ min-width: [0-9]px, width: [x] }` to table cell.
// if true, for form - occupy the rest of area. for table, do nothing.

@UITag.set({ default: true })
export class uiColumnSize extends BaseUITag {
    appliedTo: EUITagTarget[] = [
        EUITagTarget.FormElement,
        EUITagTarget.TableHeaderCellContainer,
    ];
    ruleTypes: EUITagRuleUnion[] = [
        EUITagRuleType.Object,
        EUITagRuleType.Boolean,
        EUITagRuleType.String,
        EUITagRuleType.Number,
    ];
    allowNullRule: boolean = false;

    /// set props :description
    parse(input: IUITagInput): IUITagResult | null {
        if (input.target === EUITagTarget.FormElement)
            return handleFormElement.call(this, input);
        if (input.target === EUITagTarget.TableHeaderCellContainer)
            return handleTableHeaderCellContainer.call(this, input);

        console.log(`<uiColumnSize> unhandled target "${input.target}".`);
        return null;
    }
}

function handleFormElement(this: uiColumnSize, input: IUITagInput): IUITagResult | null {
    let rule = this.parseRule(input);

    if (input.isDefault) {
        /// make default as 12
        rule = rule ?? 12;
    }
    if (rule == null) return null;

    /// show error for `min`.
    if (typeof rule === "object") {
        console.log(`<uiColumnSize> cannot handle object type for form element.`);
        return null;
    }

    /// normal case
    return {
        props: {
            class: {
                [rule == true ? "col" : `col-md-${rule}`]: true,
            },
        },
    };
}

function handleTableHeaderCellContainer(
    this: uiColumnSize,
    input: IUITagInput,
): IUITagResult | null {
    let rule = this.parseRule(input);

    if (input.isDefault) {
        rule = rule ?? "auto";
    }
    if (rule == null || rule == true) return null;

    return {
        styles: {
            width: typeof rule === "string" ? rule : (rule as any).width,
            "min-width":
                typeof rule === "string" ? undefined : (rule as any)["min-width"],
        },
    };
}
